// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__25ap4","select":"Header_select__1DZ3O","clinic":"Header_clinic__1fILL"};